module.exports = __webpack_public_path__ + "static/media/uninstall.84744125.ico";